import Error from '../model/Error';
import axios from 'axios';

export default class ClubReverseInvoiceRepository {
    static deleteByInvoiceId(clubReverseInvoiceId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/reverse-invoices/${clubReverseInvoiceId}`)
                .then((response) => resolve(response))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
